import { useClientsList } from '../../clients/contexts/clients';
import { useFarmsList } from '../../farms/contexts/farms';

// Filtros del panel de informes. Controlado por el padre (dashboard.jsx).
// `from`/`to` viajan como 'YYYY-MM-DD' crudos del <input type="date"> (TZ-safe).
// La finca se acota por el cliente elegido (owner_id).

const today = () => new Date().toLocaleDateString('en-CA');

export default function KpiFilters({ value, onChange, onRefresh, busy }) {
    const { data: clientsData } = useClientsList({ limit: 200 });
    const clients = clientsData?.items ?? [];

    const farmFilter = value.client_id ? { owner_id: value.client_id, limit: 200 } : { limit: 200 };
    const { data: farmsData } = useFarmsList(farmFilter);
    const farms = farmsData?.items ?? [];

    return (
        <div className="report-filters">
            <label className="report-filters__group">
                <span className="report-filters__label">Cliente</span>
                <select
                    value={value.client_id}
                    onChange={(e) => onChange({ client_id: e.target.value, farm_id: '' })}
                    disabled={busy}
                >
                    <option value="">Todos</option>
                    {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
            </label>

            <label className="report-filters__group">
                <span className="report-filters__label">Finca</span>
                <select value={value.farm_id} onChange={(e) => onChange({ farm_id: e.target.value })} disabled={busy}>
                    <option value="">Todas</option>
                    {farms.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                </select>
            </label>

            <label className="report-filters__group">
                <span className="report-filters__label">Desde</span>
                <input type="date" value={value.from} max={value.to || today()} onChange={(e) => onChange({ from: e.target.value })} disabled={busy} />
            </label>

            <label className="report-filters__group">
                <span className="report-filters__label">Hasta</span>
                <input type="date" value={value.to} max={today()} onChange={(e) => onChange({ to: e.target.value })} disabled={busy} />
            </label>

            <button type="button" className="report-filters__refresh" onClick={onRefresh} disabled={busy}>
                {busy ? 'Actualizando…' : 'Actualizar'}
            </button>
        </div>
    );
}
